import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import ProChioseTree from "@/components/pro-common/pro-chiose-modal/pro-chiose-tree.vue";
export default {
  name: "pro-chiose-tab-position",
  components: {
    ProChioseTree
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    treeData: {
      type: Array,
      default() {
        return [];
      }
    },
    visible: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    _treeData() {
      let treeData = JSON.parse(JSON.stringify(this.treeData));
      this.onInitData(treeData);
      return treeData;
    }
  },
  methods: {
    onInitData(treeData) {
      treeData.forEach(v => {
        v.children = v.apps;
        v.expand = true;
        v.disabled = true;
        v.isCheckDisabled = true;
        v.children.forEach(a => {
          a.disabled = true;
        });
      });
    },
    onChange(item) {
      let checkedList = [...this.value];
      if (item.isCheck) {
        checkedList.unshift(item);
      } else {
        checkedList = checkedList.filter(v => v.id !== item.id);
      }
      this.$emit("input", checkedList);
    }
  }
};